// 運送業務発注書印刷内の定数

import { T検索日種別コード } from "../../../constant/enum/frontend"
import { TUnsogyomuHatyusyoGetReq } from "../../../service/order/unsogyomuHatyusyo/TUnsogyomuHatyusyo"

export const 積地Bindings = ["積地社名", "積地市区町村"]
export const 卸地Bindings = ["卸地社名", "卸地市区町村"]

export type T運送業務発注書表示用検索条件<T extends T検索日種別コード> =
  TUnsogyomuHatyusyoGetReq<T>

export type T運送業務発注書表示用検索共通 = Omit<
  T運送業務発注書表示用検索条件<T検索日種別コード>,
  "積日From" | "積日To" | "卸日From" | "卸日To"
>
